import type { ISettingsPageProps } from '$/pages/settings';

import React from 'react';

import SettingsPageView from './SettingsPageView';

import useCurrentUser from '$/hooks/useCurrentUser';

const SettingsPage = (props: ISettingsPageProps) => {
  const currentUser = useCurrentUser();
  return <SettingsPageView {...props} {...currentUser} />;
};

export default SettingsPage;
